/** Public legal pages on the marketing site. */
export const PRIVACY_POLICY_URL = 'https://nabat.ai/privacy-policy';
export const TERMS_AND_CONDITIONS_URL = 'https://nabat.ai/terms-and-conditions';
export const COOKIE_POLICY_URL = 'https://nabat.ai/cookie-policy';
